import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createElementBlock, Fragment, renderList, normalizeClass, createTextVNode, toDisplayString } from "vue";
import { useDatePickerContext, DatePickerView, DatePickerTableCell, DatePickerTableCellTrigger } from "@ark-ui/vue/date-picker";
import Header from "./Header.vue.js";
const _hoisted_1 = { class: "elfie-datepicker__table" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "YearView",
  setup(__props) {
    const datePicker = useDatePickerContext();
    const isYearDisabled = (yearValue, datePicker2) => {
      try {
        const state = datePicker2.getYearTableCellState({ value: yearValue });
        return state.disabled || !state.selectable || state.outsideRange;
      } catch {
        return false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DatePickerView), { view: "year" }, {
        default: withCtx(() => [
          createVNode(Header),
          createElementVNode("table", _hoisted_1, [
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).getYearsGrid({
                columns: 4
              }), (years, rowId) => {
                return openBlock(), createElementBlock("tr", { key: rowId }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(years, (year, yearId) => {
                    return openBlock(), createElementBlock("td", {
                      key: yearId,
                      class: "elfie-datepicker__table-cell"
                    }, [
                      createVNode(unref(DatePickerTableCell), {
                        value: year.value
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(DatePickerTableCellTrigger), {
                            class: normalizeClass([
                              "elfie-datepicker__year-cell",
                              {
                                "elfie-datepicker__year-cell--disabled": isYearDisabled(year.value, unref(datePicker))
                              }
                            ])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(year.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=YearView.vue2.js.map
